import React from "react";
import ReactDOM from "react-dom";
import "./css/index.css";
import "./css/Grid.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/index";
import "promise-polyfill/src/polyfill";
import "whatwg-fetch";

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename="/af/">
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js